import script from "./FourPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FourPage.vue?vue&type=script&setup=true&lang=js"

import "./FourPage.vue?vue&type=style&index=0&id=51e62865&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e62865"]])

export default __exports__